export const blog = {
  // META
  'blog.meta.title': 'Blog',
  'blog.meta.title.with_category': '{category} | Blog',
  'blog.meta.description': '',

  // TEXTS
  'blog.header.not_found': 'Tento článek neexistuje.',
  'blog.header.title': 'Blog',
  'blog.header.back': 'Zpět na výpis článků',
  'blog.next_posts': 'Další články',
  'blog.no_posts': 'Nejsou zde žádné články',
  'blog.btn.title': 'Číst článek',
  'blog.category_select.no_category': 'Kategorie (vše)',
};
